import { render, staticRenderFns } from "./camt053Parser.vue?vue&type=template&id=7bf4d042&scoped=true&"
import script from "./camt053Parser.vue?vue&type=script&lang=js&"
export * from "./camt053Parser.vue?vue&type=script&lang=js&"
import style0 from "./camt053Parser.vue?vue&type=style&index=0&id=7bf4d042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4d042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCard,VChip})
